import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import React, { useState } from "react";
import { SideBarItems } from "../../@types/SideBar.d";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Flex,
  Image,
  Stack,
  useMantineTheme,
} from "@mantine/core";
import { ParentPageEvents } from "../../utilities/Mixpanel/AnalyticEventParentApp";
import { WebAppEvents } from "../../utilities/Mixpanel/AnalyticeEventWebApp";
import { Mixpanel } from "../../utilities/Mixpanel/MixpanelHelper";
import styled from "styled-components";
import { ISimulation } from "../_New/NewPageDesign/ModifiedOptionsSim";

enum SimulationTypeEnum {
  UNITY,
  THREEJS,
  MODELJSON,
  REACTIONJSON,
}

interface IProps {
  _id: string;
  name: string;
  lgNo?: number;
  imageUrl: string | undefined;
  simulationTags: string[];
  setShowAuthModal: (val: boolean) => void;
  setSimualtionId: (val: string) => void;
  setPlaySimulation: (val: ISimulation) => void;
  paramValue: string | null;
  userSubscriptionType: string;
  isSimulationPremium: boolean;
  setModalSimulation: (val: any) => void;
  videoUrl: string;
  showInfo: boolean;
  simulationType?: number;
  simulationClickHandler?: (name: string, _id: string) => void;
  simulation?: ISimulation;
}

const TeachSimulationCard: React.FC<IProps> = (props) => {
  const [modalHover, setModalHover] = useState(false);
  const [hovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md}px)`);

  const handleOpenSimulation = () => {
    props.setModalSimulation(props.simulation);
  };

  const handleOnButtonCLick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();

    if (props.userSubscriptionType === "FREE") {
      if (
        props.isSimulationPremium === undefined ||
        props.isSimulationPremium
      ) {
        Mixpanel.track(WebAppEvents.VIGNAM_APP_PREMIUM_FEATURE_ACCESSED, {
          feature_name: "premium_simulation_accessed",
          current_page: "all_simulations_page",
        });
      } else {
        props.setPlaySimulation(props.simulation!!);
        if (props.simulationClickHandler) {
          props.simulationClickHandler(props.name, props._id);
        }
      }
    } else if (props.userSubscriptionType !== "FREE") {
      if (
        props.isSimulationPremium === undefined ||
        props.isSimulationPremium
      ) {
        props.setPlaySimulation(props.simulation!!);
        if (props.simulationClickHandler) {
          props.simulationClickHandler(props.name, props._id);
        }
      } else {
        props.setPlaySimulation(props.simulation!!);
        if (props.simulationClickHandler) {
          props.simulationClickHandler(props.name, props._id);
        }
      }
    }
    if (props.paramValue && props.paramValue === "parent") {
      Mixpanel.track(
        ParentPageEvents.PARENT_APP_SIMULATION_PAGE_SIMULATION_CLICKED,
        {
          simulationName: props.name,
          id: props._id,
        }
      );
    } else
      Mixpanel.track(
        WebAppEvents.TEACHER_APP_SIMULATION_PAGE_SIMULATION_CLICKED,
        {
          simulationName: props.name,
          id: props._id,
        }
      );
  };

  const handleNameClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    if (props.userSubscriptionType === "FREE") {
      if (
        props.isSimulationPremium === undefined ||
        props.isSimulationPremium
      ) {
        Mixpanel.track(WebAppEvents.VIGNAM_APP_PREMIUM_FEATURE_ACCESSED, {
          feature_name: "premium_simulation_accessed",
          current_page: "all_simulations_page",
        });
      } else {
        props.setPlaySimulation(props.simulation!!);
      }
    } else if (props.userSubscriptionType !== "FREE") {
      if (
        props.isSimulationPremium === undefined ||
        props.isSimulationPremium
      ) {
        props.setPlaySimulation(props.simulation!!);
      } else {
        props.setPlaySimulation(props.simulation!!);
      }
    }
    if (props.paramValue && props.paramValue === "parent") {
      Mixpanel.track(
        ParentPageEvents.PARENT_APP_SIMULATION_PAGE_SIMULATION_CLICKED,
        {
          simulationName: props.name,
          id: props._id,
        }
      );
    } else
      Mixpanel.track(
        WebAppEvents.TEACHER_APP_SIMULATION_PAGE_SIMULATION_CLICKED,
        {
          simulationName: props.name,
          id: props._id,
        }
      );
  };

  return (
    <Box
      style={{
        cursor: "pointer",
        height: "100%",
        width: "100%",
        marginTop: "0",
      }}
      className="herethis"
    >
      <div
        className=""
        style={{
          border: "1px solid black",
          borderRadius: "12px",
          height: "100%",
          width: "100%",
          backgroundColor: "white",
        }}
      >
        <img
          src={props.imageUrl}
          alt="Props"
          style={{
            width: "100%",
            aspectRatio: "16/6",
            cursor: "pointer",
            borderRadius: "12px 12px 0 0",
          }}
          className="simulation-img"
        />

        <Button
          variant="light"
          size="xl"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            position: "absolute",
            top: "35%",
            left: "50%",
            width: "50px",
            height: "50px",
            transform: "translate(-50%, -50%)",
            padding: "10px",
            border: "3px solid white",
            borderColor: "white",
            borderRadius: "50%",
            cursor: "pointer",
            fontSize: "18px",
            transition: "background-color 0.3s",
            opacity: hovered ? 0.8 : 1,
            backgroundColor: hovered ? "lightgrey" : "transparent",
          }}
          onClick={() => props.setPlaySimulation(props.simulation!!)}
        >
          <img
            src={require("../../assets/playBtn.png")}
            alt="Play"
            style={{ width: "18px", height: "18px" }}
          />
        </Button>

        <div style={{ marginBottom: "5px", padding: "2px" }}>
          <div
            style={{
              width: "100%",
              padding: "0",
              wordWrap: "break-word",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  paddingLeft: "5px",
                }}
              >
                <Stack w={"100%"} align={"start"} justify={"space-between"}>
                  <Box w={"100%"}>
                    <span
                      style={{
                        fontSize: "16px",
                        fontFamily: "Nunito",
                        fontWeight: "700",
                        cursor: "pointer",
                        marginBottom: "1px",
                      }}
                      onClick={handleNameClick}
                    >
                      {isMd ? (
                        props.name.length > 35 ? (
                          <>{props.name.slice(0, 35)}...</>
                        ) : (
                          <>{props.name}</>
                        )
                      ) : props.name.length > 20 ? (
                        <>{props.name.slice(0, 20)}...</>
                      ) : (
                        <>{props.name}...</>
                      )}
                    </span>
                  </Box>

                  <Flex gap={6}>
                    {(props.simulationType === SimulationTypeEnum.UNITY ||
                      props.simulationType === undefined) && (
                      <Image
                        src={require("../../assets/unityIcon.png")}
                        width={"23px"}
                      />
                    )}

                    {props.simulationType === SimulationTypeEnum.THREEJS && (
                      <Image
                        src={require("../../assets/threejsIcon.png")}
                        width={"23px"}
                      />
                    )}

                    {props.simulationType === SimulationTypeEnum.MODELJSON && (
                      <>
                        <Image
                          src={require("../../assets/threejsIcon.png")}
                          width={"23px"}
                        />
                        <Image
                          src={require("../../assets/3DmodelsIcon.png")}
                          width={"23px"}
                        />
                      </>
                    )}
                    {props.simulationType ===
                      SimulationTypeEnum.REACTIONJSON && (
                      <>
                        <Image
                          src={require("../../assets/threejsIcon.png")}
                          width={"23px"}
                        />
                        <Image
                          src={require("../../assets/reactionIcon.png")}
                          width={"23px"}
                        />
                      </>
                    )}
                  </Flex>
                </Stack>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default TeachSimulationCard;

const TextInfoContainer = styled.div``;
